import React from 'react'
import { styled } from "../../stitches.config";
import { Link } from 'react-router-dom';

import { ReactComponent as Arrow } from '../assets/icons/arrow-left-nav.svg?react'

type PaginatorProps = {
    currentPage: number,
    urlLocation: string,
    pages: number,
    onPrevClick: Function,
    onNextClick: Function,
    onPageChange: Function
}

const Paginator = (props: PaginatorProps) => {

    const { currentPage, urlLocation } = props;
    const totalPages = props.pages;

    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
    }

    const handlePrevClick = () => {
        currentPage <= 1 ? null : props.onPrevClick();
    }

    const handleNextClick = () => {
        currentPage >= pages.length ? null : props.onNextClick()
    }

    const handlePageClick = (number: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
        props.onPageChange(Number(number.currentTarget.textContent));
    }



    const pageNumbers = pages.map(page => {
        if (page) {
            return (
                <li key={page} onClick={(event) => { handlePageClick(event) }}
                    className={currentPage === page ? 'active' : ''}>
                    <Link to={`/posts-map/${urlLocation},${page}`}>{page}</Link>
                </li>
            )
        } else {
            return null;
        }
    });

    return (
        <PaginatorWrapper>
            <button onClick={handlePrevClick}><Link to={`/posts-map/${urlLocation},${currentPage == 1 ? 1 : currentPage - 1}`}><Arrow /></Link></button>
            <ul>
                {pageNumbers}
            </ul>
            <button onClick={handleNextClick}><Link to={`/posts-map/${urlLocation},${currentPage == pages.length ? pages.length : currentPage + 1}`}><Arrow /></Link></button>
        </PaginatorWrapper>
    )
}

export default Paginator;

const PaginatorWrapper = styled('div', {
    display: 'flex',
    width: 'min-content',
    alignSelf: 'center',
    gap: '16px',
    marginBottom: '50px',
    button: {
        background: '$grayscale0',
        padding: 0,
        color: '$grayscale100',
        borderRadius: '50%',
        width: '24px',
        height: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        a: {
            textDecoration: 'none',
            color: '$grayscale100',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
        }
    },
    'button:last-child': {
        transform: 'rotate(180deg)',
    },
    ul: {
        display: 'flex',
        gap: '8px',
        color: '$grayscale100',
        padding: 0,
        margin: 0,
        li: {
            width: "24px",
            height: '24px',
            borderRadius: '50%',
            listStyle: 'none',
            background: '$grayscale0',
            transition: '0.2s',
            '&.active': {
                background: '$primary',
            },
            a: {
                textDecoration: 'none',
                color: '$grayscale100',
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
            },

        }
    }
})